<div class="page-wrapper"
     [tradeClass]="'is-trade'"
     [elementHeight]="'app'">

    <app-busy-state></app-busy-state>

    <router-app-busy-state></router-app-busy-state>

    <page-header #pageHeader
                 [offCanvasState]="offCanvasState"></page-header>

    @if (hasHeader) {
    <div [class.page-content]="hasPageContentClass">
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
    }

    <ng-container *afterContentInit="'router'">

        <!-- page footer -->
        <ng-container *ifTradeStore>
            <ng-container *ifUrlNotContain="['checkout', 'login']">
                <page-footer></page-footer>
            </ng-container>
        </ng-container>

        <ng-container *ifNotTradeStore>
            <ng-container *ifUrlNotContain="['checkout']">
                <page-footer></page-footer>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-container *afterContentInit>

        <!-- off canvas menu -->
        <off-canvas-menu [offCanvasState]="offCanvasState"
                         [toggleClass]="'_visible'"
                         [toggleClassBy]="offCanvasState"
                         *ifSize="'MS'"></off-canvas-menu>

        <basket-add-notice *ifSize="'S'"
                           [autoClose]="5000"></basket-add-notice>
    </ng-container>
</div>
<!-- <cms-toggle></cms-toggle> -->